import React from "react";
import { ModeRendererProps } from "./types";

// VASARELY × LOUIS VUITTON: Monogram logic — repetition as trust
// Tessellation, gold motifs, lattice monogram grids
export function VasarelyLouisVuittonMode({ brand }: ModeRendererProps) {
  const lvBrown = "#6B4423";
  const lvGold = "#D4AF37";

  return (
    <g>
      {/* Signature brown background */}
      <rect x="0" y="0" width="794" height="1123" fill={lvBrown} opacity="0.9" />

      <g transform="translate(397 540)">
        {/* Monogram tessellation pattern */}
        {Array.from({ length: 12 }).map((_, i) =>
          Array.from({ length: 16 }).map((_, j) => {
            const x = (i - 5.5) * 55;
            const y = (j - 7.5) * 50;
            const offset = (i + j) % 2 === 0 ? 0 : 25;
            
            return (
              <g key={`${i}-${j}`}>
                {/* LV monogram simplified as interlocking circles */}
                <circle
                  cx={x - 10}
                  cy={y + offset}
                  r="18"
                  fill="none"
                  stroke={lvGold}
                  strokeWidth="2"
                  opacity="0.4"
                />
                <circle
                  cx={x + 10}
                  cy={y + offset}
                  r="18"
                  fill="none"
                  stroke={lvGold}
                  strokeWidth="2"
                  opacity="0.4"
                />
                {/* Flower motif */}
                <circle
                  cx={x}
                  cy={y - 20 + offset}
                  r="6"
                  fill={lvGold}
                  opacity="0.5"
                />
              </g>
            );
          })
        )}

        {/* Lattice grid structure */}
        {Array.from({ length: 16 }).map((_, i) => {
          const angle = (i * Math.PI) / 8;
          return (
            <line
              key={i}
              x1="0"
              y1="0"
              x2={Math.cos(angle) * 280}
              y2={Math.sin(angle) * 280}
              stroke={lvGold}
              strokeWidth="1"
              opacity="0.2"
            />
          );
        })}

        {/* Gold accent circles */}
        {Array.from({ length: 12 }).map((_, i) => {
          const r = 60 + i * 20;
          return (
            <circle
              key={i}
              cx="0"
              cy="0"
              r={r}
              fill="none"
              stroke={lvGold}
              strokeWidth="1.5"
              opacity={0.25 - i * 0.015}
            />
          );
        })}

        {/* Trust signal nodes */}
        {[0, 60, 120, 180, 240, 300].map((angle) => {
          const rad = (angle * Math.PI) / 180;
          const r = 220;
          return (
            <g key={angle}>
              <circle
                cx={Math.cos(rad) * r}
                cy={Math.sin(rad) * r}
                r="10"
                fill={lvGold}
                opacity="0.6"
              />
              {/* Four-petal flower */}
              {[0, 90, 180, 270].map((petal) => {
                const pRad = ((angle + petal) * Math.PI) / 180;
                return (
                  <circle
                    key={petal}
                    cx={Math.cos(rad) * r + Math.cos(pRad) * 8}
                    cy={Math.sin(rad) * r + Math.sin(pRad) * 8}
                    r="4"
                    fill={lvGold}
                    opacity="0.5"
                  />
                );
              })}
            </g>
          );
        })}

        {/* Central monogram frame */}
        <rect x="-100" y="-100" width="200" height="200" fill="none" stroke={lvGold} strokeWidth="3" opacity="0.5" rx="10" />
      </g>

      {/* LV inscription */}
      <text x="397" y="1020" textAnchor="middle" fontFamily="serif" fontSize="11" fill={lvGold} opacity="0.7" fontStyle="italic">
        logique du monogramme
      </text>
    </g>
  );
}
